import { SexService } from "../../services/models/sex";
const moduleSex = {
	namespaced: true,
	state: {
		sexs: [],
		loading: false,
	},
	getters: {
		getSexs(state) {
			return state.sexs;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadSexs(state, sexs) {
			state.sexs = sexs;
		}
	},
	actions: {
		async loadSexs({ commit, state }) {
			state.loading = true;
			let sexs = await SexService.getAll();
			commit("loadSexs", sexs);
			state.loading = false;
		}
	}
}

export default moduleSex;